export const NaturalBlue = ({
  className,
  accent1,
  accent2,
}: {
  className?: string;
  accent1?: string;
  accent2?: string;
}) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width="48"
    height="168"
    viewBox="0 0 48 168"
    fill="none"
  >
    <g clipPath="url(#clip0_3736_1823)">
      <rect width="48" height="168" fill={accent1} />
      <path d="M0 132L-1.57361e-06 168L34 168" fill={accent2} />
      <path d="M48 132L48 168L14 168" fill={accent2} />
    </g>
    <defs>
      <clipPath id="clip0_3736_1823">
        <rect width="48" height="168" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
